<template>
  <div>
    <div v-if="object['SubObjects'] !== undefined"
         :class="object.Location ? '' : props.depth % 2 == 0? 'objectOdd':'objectEven'"
    >
      <div style="margin:0.5rem;">
        <b>{{ object.Location ? "" : object.Name }}</b>
      </div>
      <template v-for="(subObject) in sortedSubObjects"
                :key="subObject.Id"
      >
        <RecursiveObjects :task-id="props.taskId"
                          :depth="props.depth+1"
                          :object="subObject"
                          :service-object-ids="props.serviceObjectIds.concat([subObject.Id])"
        />
      </template>
    </div>
    <div v-else
         :class="(props.depth % 2 == 0? 'objectOdd':'objectEven') + ` expandableObj ${!object.Hidden && 'is-expandedObj'} ${object.Hidden && checkControls(object) && object.InspectionStatus === 1 && 'bgreen2' || object.Hidden && checkControls(object) && object.InspectionStatus === 2 && 'bred2'} serviceobjects`"
    >
      <div class="content">
        <div class="info">
          <rowResp container
                   :gutter="12"
                   @click="serviceObjectOpen(object)"
          >
            <columnResp :xs="5"
                        :md="2"
                        :lg="2"
                        :xl="2"
            >
              <div class="tbold">
                {{ $t("inspection.Position") }}
              </div>
              {{ object.Position }}&nbsp;
            </columnResp>
            <columnResp :xs="5"
                        :md="3"
                        :lg="3"
                        :xl="3"
            >
              <div class="tbold">
                {{ $t("inspection.Floor") }}
              </div>
              {{ object.Floor }}&nbsp;
            </columnResp>
            <columnResp :xs="5"
                        :md="3"
                        :lg="3"
                        :xl="3"
            >
              <div class="tbold">
                {{ $t("inspection.EquipmentType") }}
              </div>
              {{ object.EquipmentType }}&nbsp;
            </columnResp>
            <columnResp :xs="5"
                        :md="3"
                        :lg="3"
                        :xl="3"
            >
              <div class="tbold">
                {{ $t("inspection.Placement") }}
              </div>
              {{ object.Placement }}&nbsp;
            </columnResp>
            
           
            <columnResp v-if="object.Hidden && checkControls(object)"
                        rowspan="2"
                        :xs="2"
                        :md="1"
                        :lg="1"
                        :xl="1"
                        :class="`${object.InspectionStatus === 1 && 'bgreen' || object.InspectionStatus === 2 && 'bred'} buttonRow`"
            >
              <button class="saveButton2"
                      @click="ToggleHideItem(object)"
              />
            </columnResp>
          </rowResp>
        </div>
      
      
        <div v-if="object.InspectionStatus === 2"
             :class="`expandable ${!object.Hidden && 'is-expanded'}`"
        >
          <rowResp container
                   :gutter="12"
          >
            <columnResp :xs="12"
                        :sm="12"
                        :md="12"
                        :lg="6"
                        :xl="5"
            >
              <div class="column">
                <p>{{ $t("inspection.Remark") }}</p>
                <select class="_select"
                        name="remarkOptions"
                        @change="setRemark($event.target.selectedIndex, object)"
                >
                  <option v-for="remarkOption in object.RemarkOptions"
                          :key="remarkOption"
                          :selected="remarkOption === object.Remark"
                          :value="remarkOption"
                  >
                    {{ remarkOption }}
                  </option>
                </select>
              </div>
            </columnResp>

            <columnResp :xs="12"
                        :sm="12"
                        :md="12"
                        :lg="6"
                        :xl="5"
            >
              <div class="column">
                <p>{{ $t("inspection.Comment") }}</p>
                <textarea class="_textInput"
                          name="classifications"
                          :value="object.Comment"
                          @focus="resize($event)"
                          @keyup="resize($event)"
                          @change="setComment($event.target.value, object)"
                />
              </div>
            </columnResp>

            <columnResp :xs="6"
                        :sm="4"
                        :md="4"
                        :lg="2"
                        :xl="2"
            >
              <div class="column">
                <p>{{ $t("inspection.RequestHelp") }}</p>
                <input id="checkboxInputOverride"
                       class="_reqHelp"
                       type="checkbox"
                       name="requestHelp"
                       :checked="object.RequestService"
                       @change="setRequestService($event.target.checked, object)"
                >
              </div>
            </columnResp>
          </rowResp>
        </div>
        <div 
          :class="`expandable ${!object.Hidden && 'is-expanded'}`"
        >
          <form style="padding-top:10px">
            <div ref="radios"
                 class="radio"
            >
              <input :class="`${object.InspectionStatus === 1 && 'hasNoDeviation'}`"
                     label="&check;"
                     type="radio"
                     name="deviations"
                     value="1"
                     :checked="object.InspectionStatus === 1 ? true:false"
                     @change="radioChange($event.target.value, object, 1)"
              >
              <input label="&#9472;"
                     type="radio"
                     name="deviations"
                     value="0"
                     :checked="object.InspectionStatus === 0 ? true:false"
                     class="minusButton"
                     @change="radioChange($event.target.value, object)"
              >
              
              <input :class="`${object.InspectionStatus === 2 && 'hasDeviation'}`"
                     label="&#9932;"
                     type="radio"
                     name="deviations"
                     value="2"
                     :checked="object.InspectionStatus === 2 ? true:false"
                     @mouseover="mouseOver = true"
                     @mouseleave="mouseOver = false"
                     @change="radioChange($event.target.value, object)"
              >
            </div>
            <div v-if="checkControls(object)"
                 :class="`button-expandable ${!object.Hidden && 'button-is-expanded'} buttonRow`"
            >
              <button class="saveButton"
                      @click.prevent="ToggleHideItem(object)"
              >
                {{ $t("inspection.Finish") }}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import RecursiveObjects from '@/components/RecursiveObjects.vue'
import { defineProps,onMounted, computed,ref  } from "vue";
import { useStore} from "vuex";
import { useToast } from "vue-toastification";
import i18n from '../locales/i18n'
import { SortByTextAndNumber } from '@/utils/array';
const toast = useToast();
const store = useStore();

const sortedSubObjects = computed(() => props.object ? JSON.parse(JSON.stringify(props.object))['SubObjects'].sort(SortByTextAndNumber('Name', 'Position')): undefined)
const radios = ref(null);

const props = defineProps({
  
  taskId: {
    type: Number,
    default () {
      return -1
    }
  }, 
  object: {
    type: Object,
    default () {
      return []
    }
  }, 
  depth:{
    type: Number,
    default (){
        return 0
    }
  },
  serviceObjectIds:{
    type: Array,
    default () {
      return []
    }
  }, 
});


onMounted(async () => {
});


function checkControls(serviceObject){
     if(serviceObject.InspectionStatus === 2){
        return true;
      }
      else if (serviceObject.InspectionStatus === 1){
         return true;
      }
      return false
}


function serviceObjectOpen(serviceObject){
   store.dispatch("tasks/showServiceObject", {
    taskId: props.taskId,
    indexes: props.serviceObjectIds,
    serviceObjectId: serviceObject.Id,
  });
}

async function ToggleHideItem(serviceObject, value){
  const originalValue =  JSON.parse(JSON.stringify(serviceObject.InspectionStatus))
  if((value === 2 && serviceObject.InspectionStatus === 2) || (value === undefined && serviceObject.InspectionStatus === 2)){
    //&& '' + serviceObject.Id === localStorage.getItem('ServiceObjectId')
    if(serviceObject.Remark !== "" ){
      
      const result = await store.dispatch("tasks/updateInspection", serviceObject);
      if(result){
        store.dispatch("tasks/setHiddenServiceObject", {
          taskId: props.taskId,
          indexes: props.serviceObjectIds,
          serviceObjectId: serviceObject.Id,
        });
      }
      else{
        toast.info(i18n.global.t("inspection.networkIssue"), {
          timeout: 3000
        });
        radios.value.querySelectorAll('input[name="deviations"]').forEach(radio => {
          if(radio.value == originalValue)
            radio.checked = true;
          else 
            radio.checked = false;
        });
      }
    }
    else{
      toast.error(i18n.global.t("inspection.FieldRequired"), {
        timeout: 2500
      });
    }
  }else if(value === 1 || serviceObject.InspectionStatus === 1){
    store.dispatch("tasks/setHiddenServiceObject", {
    taskId: props.taskId,
    indexes: props.serviceObjectIds,
    serviceObjectId: serviceObject.Id,
  });
  }

  //Här skickas uppdatering av serviceObject.
}


async function radioChange(value, serviceObject, toggleHideItem) {
  const originalValue =  JSON.parse(JSON.stringify(serviceObject.InspectionStatus))
  if(value == 2){
    toast.info(i18n.global.t("inspection.Info"), {
        timeout: 2500
      });
  }
  const result = await store.dispatch("tasks/addDeviations", {
    taskId: props.taskId,
    indexes: props.serviceObjectIds ,
    serviceObjectId: serviceObject.Id,
    value: value,
  });
  
  
  if(result && toggleHideItem){
    ToggleHideItem(serviceObject, 1)
  }
  if(!result){
    toast.info(i18n.global.t("inspection.networkIssue"), {
        timeout: 3000
      });
    radios.value.querySelectorAll('input[name="deviations"]').forEach(radio => {
      if(radio.value == originalValue)
        radio.checked = true;
      else 
        radio.checked = false;
    });
  }

}


function setRemark(selectedIndex, serviceObject) {
  store.dispatch("tasks/setRemark", {
    taskId: props.taskId,
    indexes: props.serviceObjectIds,
    serviceObjectId: serviceObject.Id,
    value: serviceObject.RemarkOptions[selectedIndex],
  });
}

function setComment(value, serviceObject) {
  store.dispatch("tasks/setComment", {
    taskId: props.taskId,
    indexes: props.serviceObjectIds,
    serviceObjectId: serviceObject.Id,
    value: value
  });
}
function setRequestService(value, serviceObject) {
  store.dispatch("tasks/setRequestService", {
    taskId: props.taskId,
    indexes: props.serviceObjectIds,
    serviceObjectId: serviceObject.Id,
    value: value,
  });
}

function resize(event) {
  event.target.style.height = event.target.scrollHeight - 4 + "px";
}

</script>


<style lang="scss" scoped>

@import "../scss/input.scss";
@import "../scss/buttons.scss";

.maticon{
  position: absolute;
  font-size: 40px;
}

.maticon2{
  position: absolute;
  font-size: 40px;
  padding-right: 20px;
  z-index:0;
}


.equipmentheader {
  font-weight: bold;
  margin: 5px;
}
.minusButton{
  display: none;
}
.column {
  min-height: 80px;
  margin-top: 10px;
  padding: 4px;
  border-radius: 10px;
  margin-bottom: 1px;
  margin-right: 2px;
  background: var(--light_transparent);
  border: 1px solid black;
  //box-shadow: 1px 2px 1px 1px rgba(0,0,0,0.75);
  p {
    padding: 3px;
    font-weight: bold;
  }
}
.serviceobjects {
  background: #ffffff;
  border-radius: 0;
  border-bottom: 2px solid var(--backgroundNew2);
  padding: 5px;
  margin: 10px;
  box-shadow: none;
  .serviceobjectsheader {
    font-weight: bold;
    margin: 5px;
  }
  .content {
    padding-left: 10px;
    padding-right: 10px;
    background: #ffffff;
    .tbold {
      font-weight: bold;
      padding-right: 10px;
    }
  }
  

}
.expandableObj{
    border: 0;
    border-bottom: 2px solid var(--backgroundNew2);
    height: 50px;
    &.is-expandedObj {
      height: auto !important;
      transition: height 1s ease;
    }

}
._select {
  @include select100percent;
}
._textInput {
  @include select100percent;
  text-align: left;
  resize: none;
  min-height: 30px;
  height: 30px;
  max-height: 500px;
  font-size: 0.9em;
}
._reqHelp {
  margin-left: 10px;
  height: 30px;
  width: 30px;
  background-color: #eee;
}

/**Tri state button */

body {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
}

.radio {
  margin-top: 5px;
  padding: 4px;
  border-radius: 3px;
  position: relative;
  display: inline;
}

.radio input {
  margin-right: 5px;
  width: auto;
  height: 100%;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  outline: none;
  cursor: pointer;
  border-radius: 0;
  padding: 4px 8px;
  background: #4D4D4D;
  color: #bdbdbdbd;
  font-size: 14px;
  transition: all 100ms linear;
    width: 28px;
    height: 28px;


}
.expandable {

    overflow: hidden;
    height: 0;
    transition: height 1s ease;
    &.is-expanded {
      height: auto;
      transition: height 1s ease;
    }
  }
  .button-expandable {
    display: none;
    transition: height 1s ease;

    &.button-is-expanded {
      .content{
            height: 41px;
      }
      display: inline;
      transition: height 1s ease;
    }
  }
.bgreen2{
  border:1px solid var(--inspectionGreen);
  border-bottom: 2px solid var(--backgroundNew2);
}
.bred2{
  border:1px solid var(--inspectionRed);
  border-bottom: 2px solid var(--backgroundNew2);
}

.buttonRow {
  width: 100%;
  height: 30px;
  .saveButton {
    @include btnMedium;
    float: right;
    height: 30px !important;
    margin-top: 2px;
    margin-right: 0px;
    border: 1px solid var(--topbar);
    box-shadow: rgba(0, 0, 0, 0.15) 3px 3px 3px;
    padding: 0px;
  }
}
.colorRed {
    color:rgb(207, 2, 2) !important;


  }
  .colorGreen {
      color:#009200;
  }
.radio input:checked {
  background: #4D4D4D;
  color: #fff;
  text-shadow: none;
}

.radio input:before {
  content: attr(label);
  display: inline-block;
  //text-align: center;
  //width: 100%;
    width: 28px;
    height: 28px;

}

@media(max-width:768px) {
.expandableObj{
    height: auto;
}
.deviation{
  margin-bottom: 0px;
}
}

    .objectOdd{
        border-radius: 0;
        box-shadow: none;
        padding:0.2rem;
        margin:0.75rem;
        background: #ffffff;
    }
    .objectEven{
        border-radius: 5px;
        padding:0.2rem;
        margin:0.75rem;
        background: white;
    }

    .bred{
    .saveButton2 {
      @include btnSmall;
      border-radius: 50%;
      width: 19px;
      float: right;
      margin-right: 0px;
      border: 1px solid var(--topbar);
      box-shadow: rgba(0, 0, 0, 0.15) 3px 3px 3px;
      padding: 0px;
      background-color: var(--sidebar);
      border:1px solid black;
      &:hover{
            border-radius: 50%;
            cursor: unset;
      }
    }
  }
  .bgreen{
     .saveButton2 {
      @include btnSmall;
      border-radius: 50%;
      width: 19px;
      float: right;
      margin-right: 0px;
      border: 1px solid var(--topbar);
      box-shadow: rgba(5, 0, 0, 0.15) 3px 3px 3px;
      padding: 0px;
      background-color:#009200;
      border:1px solid black;
      &:hover{
            border-radius: 50%;
            cursor: unset;
      }
    }
  }
</style>
